import {
    SET_REP_FIRST_NAME,
    SET_REP_LAST_NAME,
    SET_REP_EMAIL,
    SET_REP_PHONE,
    SET_REP_ROLE,
    SET_SALES_REP,
} from './constants';

const defaultState = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: null,
    role: '',
};

const projectreps = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SALES_REP:
            return {
                firstName: action.rep.firstName,
                lastName: action.rep.lastName,
                email: action.rep.email,
                phoneNumber: action.rep.phoneNumber,
                role: action.rep.role,
            };
        case SET_REP_FIRST_NAME:
            return { ...state, firstName: action.firstName };

        case SET_REP_LAST_NAME:
            return { ...state, lastName: action.lastName };

        case SET_REP_EMAIL:
            return { ...state, email: action.email };

        case SET_REP_PHONE:
            return { ...state, phoneNumber: action.phoneNumber };


        case SET_REP_ROLE:
            return { ...state, role: action.role };


        default:
            return state;
    }
};

export default projectreps;



// WEBPACK FOOTER //
// ./src/containers/common/projectreps/reducer.js